module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?4a837d054b5f2a37170df8a275a13816";